import { useContext } from 'react';
import { ReturnPortalContext } from '../contexts/ReturnPortalContext';

function useShopId(): number | undefined {
  const { shopId } = useContext(ReturnPortalContext);
  return shopId;
}

export default useShopId;
